module.exports = __webpack_public_path__ + "img/jp.5d7c0496.svg";